import React from "react";
import TextField from "@material-ui/core/TextField";
import Modal from "components/Tvendo/Common/ModalBase";

export default function ModalDistributionStaff(props) {
  const employeePosition = props.model;

  return (
    <Modal
      title="Posición empleado"
      model={employeePosition}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/employee-positon"
    >
      <TextField
        label="Código"
        fullWidth
        type="text"
        name="code"
        margin="normal"
        defaultValue={!!employeePosition ? employeePosition.code : ""}
        required
      />
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={!!employeePosition ? employeePosition.description : ""}
        required
      />
    </Modal>
  );
}
